import React, { PureComponent } from 'react';
import { Form, Modal } from 'antd';
import { getTranslate } from 'react-localize-redux';
import AccountCreation from './accountCreation';
import { toggleAccountCreationModal, updatePreferences } from './accountCreationActions';
import { connect } from 'react-redux';
import { withActions } from 'actionware';

@connect(({ localize, accountCreation: { showingAccountCreationModal, action }, account: { selectedAccountDetails } }) => ({
  translate: getTranslate(localize),
  showingAccountCreationModal,
  selectedAccountDetails,
  action
}))
@withActions({
  toggleAccountCreationModal,
  updatePreferences
})
@Form.create()
export default class AccountCreationModal extends PureComponent {
  componentWillReceiveProps(nextProps) {
    if (nextProps.showingAccountCreationModal && !this.props.showingAccountCreationModal) {
      this.props.form.resetFields();
    }
  }

  render() {
    const {
      showingAccountCreationModal,
      toggleAccountCreationModal,
      form,
      translate,
      action,
      selectedAccountDetails,
      updatePreferences
    } = this.props;

    const accountAction = action === 'create' ? 'hello' : updatePreferences
    return (
      <Modal
        className={'modal-form'}
        visible={showingAccountCreationModal}
        title={
          <div>
            <div className={'title'}>{action === 'create' ? translate('accountCreation.title') : translate('accountUpdate.title')}</div>
            <div className={'subtitle'}>
              {translate('accountCreation.subtitle')}
            </div>
          </div>
        }
        onCancel={toggleAccountCreationModal}
        width={630}
      >
        <AccountCreation
          form={form}
          initialValues={action === 'create' ? undefined : selectedAccountDetails}
          action={accountAction}
          accountId={action === 'create' ? undefined : selectedAccountDetails.id}
        />
      </Modal>
    );
  }
}
